import { mutateSeniority } from '../../mutations/mutateSeniority';
import { organizationAPI } from 'api/phases/endpoints';
import { serialize } from 'object-to-formdata';

export const addSeniority = async (name: string) => {
  const formData = serialize({ seniority: { name } });
  await organizationAPI.addSeniority(formData);
  await mutateSeniority();
};
